import { GET_CURRENTCOURSES } from "./actionTypes";

// eslint-disable-next-line 
export default (state = {}, action) => {
    switch(action.type) {
       case GET_CURRENTCOURSES:
          return action.payload;
       default:
          return state;  
    }
  }